import React from 'react';
const GasRelatorioDetailsView = ({ $state, GasService }) => {
    return <h1>Oi!</h1>;
};
export default GasRelatorioDetailsView;
